import { ChangeDetectionStrategy, Component, computed, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';

function paramDeger(ek: any, ismi: string): any {
  const diziden = ek?.parametreler?.find((p: any) => p.ismi === ismi)?.degeri;
  if (diziden != null) return diziden;
  return ek?.[ismi] ?? '';
}

@Component({
  selector: 'siparis-kalemi-edit',
  standalone: true,
  imports: [FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk-edit">
      <div class="sk-baslik">
        <div class="sk-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
        </div>
        <span>Sipariş Kalemi</span>
      </div>

      <div class="sk-form">
        <div class="form-grup">
          <label>Ürün Adı <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')" [ngModel]="deger('urunAdi')" (ngModelChange)="guncelle('urunAdi', $event)" placeholder="Ürün adı..."/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup">
            <label>Miktar <span class="zorunlu">*</span></label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('miktar') || 1" (ngModelChange)="guncelle('miktar', $event)" [nzMin]="1" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>Birim Fiyat</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('birimFiyat') || 0" (ngModelChange)="guncelle('birimFiyat', $event)" [nzMin]="0" [nzStep]="0.01" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="form-satir">
          <div class="form-grup">
            <label>Birim</label>
            <div class="input-wrap">
              <nz-select [ngModel]="deger('birim') || 'Adet'" (ngModelChange)="guncelle('birim', $event)" style="width:100%">
                <nz-option nzValue="Adet" nzLabel="Adet" nzCustomContent><span class="ac-opt">&#x1F4E6; Adet</span></nz-option>
                <nz-option nzValue="Kg" nzLabel="Kg" nzCustomContent><span class="ac-opt">&#x2696; Kg</span></nz-option>
                <nz-option nzValue="Ton" nzLabel="Ton" nzCustomContent><span class="ac-opt">&#x2696; Ton</span></nz-option>
                <nz-option nzValue="Metre" nzLabel="Metre" nzCustomContent><span class="ac-opt">&#x1F4CF; Metre</span></nz-option>
                <nz-option nzValue="Takım" nzLabel="Takım" nzCustomContent><span class="ac-opt">&#x1F9F0; Takım</span></nz-option>
              </nz-select>
              <div class="input-glow"></div>
            </div>
          </div>
          <div class="form-grup">
            <label>İndirim %</label>
            <div class="input-wrap">
              <nz-input-number [ngModel]="deger('indirim') || 0" (ngModelChange)="guncelle('indirim', $event)" [nzMin]="0" [nzMax]="100" [nzStep]="1" style="width:100%"></nz-input-number>
              <div class="input-glow"></div>
            </div>
          </div>
        </div>

        <div class="form-grup">
          <label>KDV %</label>
          <div class="input-wrap">
            <nz-input-number [ngModel]="deger('kdv') || 20" (ngModelChange)="guncelle('kdv', $event)" [nzMin]="0" [nzMax]="100" style="width:100%"></nz-input-number>
            <div class="input-glow"></div>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }
    .sk-edit { display: flex; flex-direction: column; padding: 0; }
    .sk-baslik { display: flex; align-items: center; gap: 10px; padding: 12px 16px; margin-bottom: 4px; border-radius: 10px; background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent); }
    .sk-baslik-ikon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; background: linear-gradient(135deg, #e65100, #ff9800); color: #fff; flex-shrink: 0; box-shadow: 0 2px 8px rgba(230,81,0,0.35); }
    .sk-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }
    .sk-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }
    .form-satir { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
    .form-grup { display: flex; flex-direction: column; gap: 5px; }
    .form-grup label { font-size: 11px; font-weight: 500; color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px; transition: color 0.2s; }
    .form-grup:focus-within label { color: var(--py-link, #1890ff); }
    .zorunlu { color: #ff4d4f; font-size: 13px; line-height: 1; vertical-align: middle; }
    .input-wrap { position: relative; }
    .input-glow { position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px; background: linear-gradient(90deg, #e65100, #ff9800, #e65100); transition: width 0.35s cubic-bezier(0.4,0,0.2,1), left 0.35s cubic-bezier(0.4,0,0.2,1), opacity 0.3s; opacity: 0; pointer-events: none; z-index: 1; }
    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }
    .input-wrap input[nz-input] { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)); border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px; padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333); transition: border-color 0.25s, background 0.25s, box-shadow 0.25s; }
    .input-wrap input[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(230,81,0,0.1); outline: none; }
    .input-wrap ::ng-deep .ant-select-selector { background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important; border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important; min-height: 34px; }
    .input-wrap ::ng-deep .ant-input-number { width: 100% !important; border-radius: 8px; }
    .ac-opt { display: flex; align-items: center; gap: 8px; }
  `],
})
export class SiparisKalemiEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (!params?.ek) return;
    params.ek[alan] = deger;
    this.parametreler.set({ ...params });
  }
}
